import { createFileRoute } from '@tanstack/react-router'
import { InvoiceDetail } from '@/features/billing/invoice-detail/InvoiceDetail'
import { usePageTitle } from '@/hooks/usePageTitle'

export const Route = createFileRoute('/_dashboard/clients/$clientId/invoices/$invoiceId')({
  component: RouteComponent,
})

function RouteComponent() {
  usePageTitle('請求書明細')
  return <InvoiceDetail />
}